import type { FC} from 'react';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { Player } from 'library/components/shop';

export const ManualModal: FC = () => {
	const navigate = useNavigate();
	const params = useParams<{ tab: string; code: string }>();
	const [isPlayerOpen, setIsPlayerOpen] = useState<boolean>(true);

	const onClose = () => {
		setIsPlayerOpen(false);
		navigate(`/shop/${params.code}/${params.tab}`);
	};

	return (
		<>
			<Player isOpen={isPlayerOpen} close={onClose} video={'FMmV9wmc'} />
		</>
	);
};
